<template>
	<div>
		<modal-confirmacao
			:exibir="exibir"
			:mensagem="mensagemExcluirPncp"
			:subtituloModal="subtituloModalExcluirPncp"
			:tituloModal="tituloModalExcluirPncp"
			@confirmar="excluirPncp"
			@fechar-modal="$emit('fechar-modal')"
		></modal-confirmacao>
	</div>
</template>
<script>
import ModalConfirmacao from '@/views/components/ModalConfirmacao.vue'
import { actionTypes } from '@/core/constants'
import validacaoAta from '@/views/mixins/validacaoAta'
import mutationTypes from '@/core/constants/mutation-types'

export default {
	name: 'modal-excluir-ata-pncp',
	components: { ModalConfirmacao },
	mixins: [validacaoAta],
	props: {
		exibir: Boolean,
	},
	data() {
		return {
			subtituloModalExcluirPncp:
				'Ao cancelar a Ata no PNCP, todos os documentos publicados, inclusive de adesões, serão removidos.',
			mensagemExcluirPncp: 'Deseja continuar?',
			tituloModalExcluirPncp: 'Cancelar PNCP',
		}
	},
	methods: {
		async excluirPncp() {
			await this.$store.dispatch(actionTypes.ATA.EXCLUIR_ATA_NO_PNCP, this.$route.params.id)
			await this.$store.dispatch(actionTypes.ATA.BUSCAR_POR_ID, this.$route.params.id)
			await this.fecharAposConfirmacao()
			this.$store.commit(mutationTypes.ATA.DOCUMENTOS_ATA.ATUALIZAR_LISTAGEM)
		},
		async fecharAposConfirmacao() {
			this.mostrarNotificacaoSucessoDefault()
			this.fecharModal()
		},
		fecharModal() {
			this.$emit('fechar-modal')
		},
	},
}
</script>
<style lang="stylus" scoped></style>
